document.addEventListener("DOMContentLoaded", function(){
  $(document).on('change', "#schedule_assignment_period_id", function(){
    $("#schedule_assignment_work_day").html(setSpinner())
    $.ajax({
      url: '/kepegawaian/jadwal_kerja/penugasan_jadwal/',
      data: {
        type: 'fetch_period',
        id: $("#schedule_assignment_period_id").val()
      },
      success: function(res) {
        $("#schedule_assignment_work_day").html(res)
      }
    })
  })
  $(document).on('click', ".schedule_assignment_group_id", function(){
    loadModal({title: `Group Detail (${$(this).closest('tr').find('td:eq(1)').text()})`, url: `/kepegawaian/jadwal_kerja/penugasan_jadwal?type=fetch_group&group_id=${$(this).attr('group_id')}`})
  })

  $(document).on('change', ".schedule_assignment_template_id", function(){
    const dom = $(this);
    const tbody = dom.closest('table').find('tbody');
    let target = undefined;
    ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function(day){
      console.log(day);
      if (tbody.find(`tr[dayname='${day}']`).length){
        target = tbody.find(`tr[dayname='${day}']`);
      } else {
        target = undefined;
      }

      if (target) {
        target.find("td[atr='in']").html(dom.find("option:selected").attr(`${day}_in`));
        target.find("td[atr='out']").html(dom.find("option:selected").attr(`${day}_out`));
        target.find("td[atr='overnight']").html(dom.find("option:selected").attr(`${day}_overnight`));
      }
    })
  })
})
